import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery, useMutation, useQueryClient } from "react-query";
import env from "../../environment";

export function useReportsGet() {
  const { data, isLoading, refetch } = useQuery(
    ["reports"],
    () =>
      makeAuthedRequest(
        `/reports`,
        {
          method: "GET",
        },
        env.apiBaseNew
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
